import "core-js"
import App, { Container } from "next/app"
import React from "react"
import Head from "next/head"
import "@/styles/global"
import Layout from "@/components/ui/layout"
import styled from "styled-components"
import queryString from "query-string"

import lpData from "@/data/data.json"

const Loader = styled.div`
  max-width: 560px;
  margin: 0 auto;
  position: absolute;
  top: 44%;
  left: 50%;
  width: 90%;
  transform: translate(-50%, -50%);
  text-align: center;

  img {
    display: block;
    margin: 0 auto;
    animation: spin 2s linear infinite;

    @keyframes spin {
      100% {
        transform: rotate(360deg);
      }
    }
  }
`

class MyApp extends App {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      loading: true,
      modelNumber: ""
    }
  }

  componentDidMount() {
    // Check the session storage for last selected model number
    const parsed = queryString.parse(window.location.search)

    if (parsed.model_name) {
      localStorage.setItem(
        "au.com.samsung.adtileconvert/model-name/",
        parsed.model_name
      )
    }

    if (!localStorage.getItem("au.com.samsung.adtileconvert/model-name/")) {
      const modelNumber = parsed.model_name
        ? parsed.model_name
        : "QA55Q60TAWXXY"
      localStorage.setItem(
        "au.com.samsung.adtileconvert/model-name/",
        modelNumber
      )
    }

    if (parsed.currentDate) {
      sessionStorage.setItem("currentDate", parsed.currentDate)
    } else {
      if (sessionStorage.getItem("currentDate")) {
        sessionStorage.removeItem("currentDate")
      }
    }

    this.setState({
      loading: false,
      data: lpData
    })
  }

  render() {
    const { Component, pageProps, page } = this.props
    const { data, modelNumber, source, loading } = this.state

    return (
      <>
        <Head key="head">
          <title>{`Samsung NFC`}</title>
        </Head>
        <Layout>
          <Container>
            {loading ? (
              <Loader>
                <img src="https://ss-adtile-nfc-production.chep.dev/static/images/icon-44x44px-loading-white.svg" />
                <h1>Getting the product details, please wait...</h1>
              </Loader>
            ) : (
              <Component
                {...data}
                modelNumber={modelNumber}
                source={source}
                pathname={this.props.router.pathname}
              />
            )}
          </Container>
        </Layout>
      </>
    )
  }
}

export default MyApp
